const getSavingsFeaturesQuery = `
  query GetAll($where: FeatureFilterInput, $after: String) {
    features(first: 250, where: $where, after: $after) {
      edges {
        node {
          category
          parentProductId
          productId
          name
          data
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export default getSavingsFeaturesQuery;
